"use client";
import { images } from "@/public";
import BlogSection from "@/src/components/sections/BlogsSection";
import HeroSection from "@/src/components/sections/HeroSection";
import SoftwareReviewsSection from "@/src/components/sections/SoftwareReviewSection/SoftwareReviewSection";
import { AppDispatch, resetState } from "@/src/store";
import { useAppDispatch, useAppSelector } from "@/src/store/hooks";
import { fetchWhitepapers } from "@/src/store/reducers/gatedContent/gatedContentThunk";
import {
  fetchBlogsDetails,
  fetchProductComparison,
  fetchSoftwareCategories,
} from "@/src/store/reducers/ungatedContent/ungatedContentThunk";
import Image from "next/image";
import { useEffect } from "react";
const page = () => {
  const { blogDetails, productCategories } = useAppSelector(
    (root) => root.unGatedContentStateReducer
  );

  const dispatch = useAppDispatch<AppDispatch>();

  useEffect(() => {
    // dispatch(resetState());    
    if (productCategories?.length === 0) {
    }
    dispatch(fetchSoftwareCategories());
    // dispatch(fetchSoftwareDetails());
    dispatch(fetchBlogsDetails());
    dispatch(fetchWhitepapers());
  }, []);

  // useEffect(() => {
  //   if (productsSelectedForComparison?.length > 0) {
  //     dispatch(
  //       fetchProductComparison({ productIds: productsSelectedForComparison })
  //     );
  //   }
  // }, [productsSelectedForComparison]);

  return (
    <main className="overflow-x-hidden">
      <HeroSection showCarousel={true} />
      <div className="hidden md:flex justify-center pt-10 bg-muted">
        <Image
          src={images.Advertise}
          alt="Advertise Image"
          width={700}
          height={700}
        />
      </div>
      <div className="md:hidden flex justify-center pt-10 bg-muted">
        <Image
          src={images.Advertise}
          alt="Advertise Image"
          width={450}
          height={65}
          className="object-contain w-4/5 min-w-[320px]"
        />
      </div>
      <SoftwareReviewsSection />

      {blogDetails && <BlogSection />}
    </main>
  );
};

export default page;
